import LegalShell from '@/components/LegalShell';
import { Mail, MapPin, Clock, MessageCircle, HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ContactPage() {
  return (
    <LegalShell eyebrow="Support" title="Get in touch.">
      <div data-testid="contact-page" className="space-y-6 text-foreground/85 leading-relaxed">
        <p>
          We’d love to hear from you. Whether it’s feedback, a support issue, a partnership idea or a
          refund question — here’s how to reach us.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 not-prose mt-4">
          <div className="rounded-2xl bg-cream-paper border border-border/70 p-5">
            <div className="h-9 w-9 rounded-xl bg-accent/60 border border-rose-tint flex items-center justify-center">
              <Mail className="h-4.5 w-4.5 text-rose-gold" />
            </div>
            <h3 className="mt-3 font-display text-xl text-ink">Email</h3>
            <a className="mt-1 block text-sm underline underline-offset-4 text-foreground" href="mailto:Webuser@radiancehub.org">
              Webuser@radiancehub.org
            </a>
            <p className="mt-1 text-xs text-muted-foreground">Typical response: 1–2 business days.</p>
          </div>
          <div className="rounded-2xl bg-cream-paper border border-border/70 p-5">
            <div className="h-9 w-9 rounded-xl bg-accent/60 border border-rose-tint flex items-center justify-center">
              <MapPin className="h-4.5 w-4.5 text-rose-gold" />
            </div>
            <h3 className="mt-3 font-display text-xl text-ink">Operating from</h3>
            <p className="mt-1 text-sm text-foreground">Mumbai, Maharashtra, India</p>
          </div>
          <div className="rounded-2xl bg-cream-paper border border-border/70 p-5">
            <div className="h-9 w-9 rounded-xl bg-accent/60 border border-rose-tint flex items-center justify-center">
              <Clock className="h-4.5 w-4.5 text-rose-gold" />
            </div>
            <h3 className="mt-3 font-display text-xl text-ink">Support hours</h3>
            <p className="mt-1 text-sm text-foreground">Mon–Fri, 10:00–19:00 IST</p>
          </div>
          <div className="rounded-2xl bg-cream-paper border border-border/70 p-5">
            <div className="h-9 w-9 rounded-xl bg-accent/60 border border-rose-tint flex items-center justify-center">
              <HelpCircle className="h-4.5 w-4.5 text-rose-gold" />
            </div>
            <h3 className="mt-3 font-display text-xl text-ink">Quick help</h3>
            <ul className="mt-1 text-sm space-y-1">
              <li><Link to="/pricing" className="underline underline-offset-4">Pricing details</Link></li>
              <li><Link to="/refund" className="underline underline-offset-4">Refund policy</Link></li>
              <li><Link to="/terms" className="underline underline-offset-4">Terms &amp; conditions</Link></li>
            </ul>
          </div>
        </div>

        <h2 className="font-display text-2xl text-ink mt-10">When writing to us, please include</h2>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Your account email;</li>
          <li>A brief description of the issue;</li>
          <li>For payment issues: the order ID and payment ID from Razorpay;</li>
          <li>Screenshots if available.</li>
        </ul>

        <p className="mt-6 text-sm text-muted-foreground flex items-center gap-2">
          <MessageCircle className="h-4 w-4" /> For beauty advice, try the Ask AI feature in the app — it’s faster than email.
        </p>
      </div>
    </LegalShell>
  );
}
